import axios from "axios";
import { authHeader } from "./utils";
import { GET_APPLICATION, LIST_APPLICATION } from "./types";

export const getApplication = (id) => async (dispatch) => {
  const res = await axios.get(`/api/applications/${id}`, {
    headers: authHeader(),
  });
  // console.log("res", res.data);
  dispatch({ type: GET_APPLICATION, payload: res.data });
};

export const fetchApplications =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/applications", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_APPLICATION, payload: res.data });
  };

export const submitApplication =
  ({ application }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/applications", application, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateApplication =
  ({ application, id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/applications/${id}`, application, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteApplication =
  ({ id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/applications/${id}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
